module.exports = __webpack_public_path__ + "pigmentace_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_2_after_tn.jpg
// module id = 1439
// module chunks = 0